export const SOURCES_LIST = [
  {
    unique_name: '876090003',
    title: 'TV',
  },
  {
    unique_name: '876090002',
    title: 'Radio',
  },
  {
    unique_name: '876090001',
    title: 'Online',
  },
  {
    unique_name: '876090005',
    title: 'Print',
  },
  {
    unique_name: '876090004',
    title: 'Mail',
  },
  {
    unique_name: '876090000',
    title: 'Family/Friends',
  },
  {
    unique_name: '876090099',
    title: 'Other (Please Specify)',
  },
];
